/**
 * Utility for conditionally joining class names.
 * @param {...(string | boolean | undefined | null)} classes
 * @returns {string}
 */
export function cn(...classes) {
  return classes.filter(Boolean).join(' ')
}
